import ReturnHeaderMeta from "@dana/Components/StandardReturns/ReturnHeaderMeta";
import { ShippingContact } from "@dana/Services/DanaStandardReturnOrderService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import TextField from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// --- Props Interface ---
interface StepShippingContactProps {
    setShippingContact: (c: ShippingContact) => void;
    onChangeInternalRef: (v: string) => void;
}

// --- Styles Interfaces and Objects ---
export interface StepShippingContactStyles {
    wrapper?: InjectableCss;
    inputGroup?: InjectableCss;
}

export const StepShippingContactStyles: StepShippingContactStyles = {
    wrapper: {
        css: css`
            display: grid;
            grid-template-columns: 1fr;
            gap: 16px;

            @media only screen and (min-width: 767px) {
                grid-template-columns: repeat(2, 1fr);
                gap: 32px;
            }
        `,
    },
};

const styles = StepShippingContactStyles;

const blank: ShippingContact = {
    firstName: "",
    phone: "",
    email: "",
    lastName: "",
};
const mapStateToProps = (state: ApplicationStateDana) => {
    return {
        shippingContact: state.standardReturnState?.shippingContact,
    };
};
type Props = ReturnType<typeof mapStateToProps> &
    StepShippingContactProps;

// --- Component Definition ---
const StepShippingContact: FC<Props> = ({
    shippingContact,
    setShippingContact,
}) => {
   
    return (
        <>
            <ReturnHeaderMeta />
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper className="input-group">
                    <TextField
                        value={shippingContact?.firstName}
                        onChange={e => setShippingContact({ ...shippingContact!, firstName: e.target.value })}
                        label={translate("First Name")}
                        required
                    />
                </StyledWrapper>
                <StyledWrapper className="input-group">
                    <TextField
                        value={shippingContact?.lastName}
                        onChange={e => setShippingContact({ ...shippingContact!, lastName: e.target.value })}
                        label={translate("Last Name")}
                        required
                    />
                </StyledWrapper>
                <StyledWrapper className="input-group">
                    <TextField
                        value={shippingContact?.email}
                        onChange={e => setShippingContact({ ...shippingContact!, email: e.target.value })}
                        label={translate("Email Address")}
                        required
                    />
                </StyledWrapper>
                <StyledWrapper className="input-group">
                    <TextField
                        value={shippingContact?.phone}
                        onChange={e => setShippingContact({ ...shippingContact!, phone: e.target.value })}
                        label={translate("Phone Number")}
                        required
                    />
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};
export default connect(mapStateToProps)(StepShippingContact)

